<div class="menu-overlay" [class.open]="isOpen" *transloco="let t">
  <div class="backdrop" (click)="close()"></div>
  <div #panel class="menu-container" (click)="$event.stopPropagation()">

    <div class="header">
      <div class="menu-header-title">
        <app-svg-icon class="logo" [path]="'/assets/logo.svg'"></app-svg-icon>
        <span class="main-title">{{ t('MENU.TITLE') }}</span>
      </div>
      <button type="button" class="menu" (click)="close()">
        <img src="/assets/closebutton.svg" [alt]="t('MENU.ALT.CLOSE')">
      </button>
    </div>

    <div class="user-row">
      <div class="user-info-container">
        <img class="profile-image" [src]="imageData" alt="User Profile"/>
        <div class="user-data">
          <span class="username">{{ userName }}</span>
          <span class="department">{{ userGroup }}</span>
        </div>
      </div>
      <button type="button" id="logout" class="logout-button" (click)="onLogoutClick()">
        <img src="/assets/logout.svg" [alt]="t('MENU.ALT.LOGOUT')"/>
      </button>
    </div>

    <div class="menu-button-list">
      @if (assignmentService.auditInProgress().length) {
        <button type="button" id="resumeAudit" class="fives-button primary-button" (click)="onResumeAuditClick()">
          {{ t('MENU.ACTIONS.RESUME-AUDIT') }}
        </button>
      } @else {
        <button type="button" id="startAudit" class="fives-button primary-button" (click)="onStartAuditClick()">
          {{ t('COMMON.LABEL.START-ADHOC') }}
        </button>
      }
      <div class="menu-elements">
        <button type="button" id="home" class="fives-button menu-button" (click)="onHomeClick()">
          {{ t('COMMON.LABEL.HOME') }}
        </button>
        <button type="button" id="myAssignment" class="fives-button menu-button" (click)="onMyAssignmentsClick()">
          {{ t('MENU.ACTIONS.MY-ASSIGNMENTS') }}
        </button>
        <!--
        <button type="button" id="feedback" class="fives-button menu-button" (click)="onFeedbackClick()">
          {{ t('MENU.ACTIONS.FEEDBACK') }} <img src="/assets/open.svg" />
        </button>
        -->
        <button type="button" id="userGuide" class="fives-button menu-button" (click)="onUserGuideClick()">
          {{ t('MENU.ACTIONS.USER-GUIDE') }} <img src="/assets/open.svg" />
        </button>
      </div>
    </div>

    <button type="button" id="settings" class="settings body-regular" (click)="onSettingsClick()">
      <i class="ph-light ph-gear"></i>{{ t('MENU.ACTIONS.SETTINGS') }}
    </button>
  </div>
</div>

<app-popup [(isOpen)]="popupVisible" [data]="popupData" [dynamicComponent]="dynamicComponent"></app-popup>
